import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SelectUndeployProduct } from './SelectUndeployProductExtension';

export const SelectUndeployProductFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SelectUndeployProduct',
    component: SelectUndeployProduct,
  }),
);

